import React, { memo } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { isYouTubeMediaUrl } from "~/utils/media";

const TrackImage = ({ width = "100%", styles = { display: 'block' }, className, link = true, track = {}, alt = "" }) => {
  const imageRoot = `//dreamchimney.com/tracks/track_images/`;
  const { id: trackId, img_url: file = '', media_id: trackMediaId = null } = track;

  const imageFilePath = imageRoot + (file ? file : `${trackId}.jpg`);
  const isYouTube = track && isYouTubeMediaUrl(track);
  const youTubeThumbnail = isYouTube && trackMediaId ? `https://i3.ytimg.com/vi/${trackMediaId}/hqdefault.jpg` : null;

  const classNamesMerge = classNames("img-fluid", className);

  const altText = alt || track.title && track.artist ? `${track.title} by ${track.artist}` : 'Cover Art';

  if (link) {
    return (
      <Link to={`/${trackId}`} style={styles}>
        <img
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = youTubeThumbnail || "//www.dreamchimney.com/tracks/track_images/default.jpg";
          }}
          src={imageFilePath}
          className={classNamesMerge}
          style={{ width }}
          alt={altText}
        />
      </Link>
    );
  } else {
    return (
      <img
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = youTubeThumbnail || "//www.dreamchimney.com/tracks/track_images/default.jpg";
        }}
        src={imageFilePath}
        className={classNamesMerge}
        style={{ width }}
        alt={altText}
      />
    );
  }
};

export default memo(TrackImage);
